import React from 'react';
import numeral from 'numeral';

import CoinUtils from './CoinUtils';
import constants from '../constants';
import SPCalc from './SPCalc';


class StakeUtils extends React.Component {

  static formatDelegateLinkForCount(cell, row) {
    if (!cell) {
        return 0;
    }

    return (<a className="animLink" href={"/val/" + row[constants.ui.identifierAttribute]}>{cell}</a>);
  }

  static formatDelegateLinkForAmount(cell, row) {
    if (!cell) {
        return 0;
    }

    return (<a className="animLink" href={"/val/" + row[constants.ui.identifierAttribute]}>{CoinUtils.stakeFormatterRounded(cell)}</a>);
  }

  static formatDelegateChangeLink(cell, row) {
    if (!cell) {
        return cell;
    }

    // return (<a className="animLink" href={"/valstats/" + row[constants.ui.identifierAttribute]}
    //   >{StakeUtils.growthStyle(row.uniqueDelegatesChange1d, false)} {StakeUtils.growthStyle(row.uniqueDelegatesChange7d, true)}</a>);

    return (<a className="animLink" href={"/valstats/" + row[constants.ui.identifierAttribute]}
      >{StakeUtils.growthStyle(cell, false)}</a>);
  }

  static formatVPChangeLink(cell, row) {
    if (!cell) {
        return cell;
    }

    // return (<a className="animLink" href={"/valstats/" + row[constants.ui.identifierAttribute]}
    //   >{StakeUtils.roundedGrowthStyle(row.votingPowerChange1d, false)} {StakeUtils.roundedGrowthStyle(row.votingPowerChange7d, true)}</a>);

    return (<a className="animLink" href={"/valstats/" + row[constants.ui.identifierAttribute]}
      >{StakeUtils.roundedGrowthStyle(cell, false)}</a>);
  }

  static roundedGrowthStyle(inputValue, addBrackets) {
    if (!inputValue) {
      return inputValue;
    }

    let style = "positiveGrowth";
    let sign = "+";
    if (inputValue < 0) {
      style = "negativeGrowth";
      sign = "";
    }

    let displayValue;
    if (addBrackets === true) {
      displayValue = "(" + sign + numeral(inputValue).format('0.0a') + ")";
    } else {
      displayValue = sign + numeral(inputValue).format('0.0a');
    }

    // return SPUtilities.moneyFormatterPrecision(inputValue, 3);
    return (<span className={style}>{displayValue}</span>);
  }

  static growthStyle(inputValue, addBrackets) {
    if (!inputValue) {
      return inputValue;
    }

    let style = "positiveGrowth";
    let sign = "+";
    if (inputValue < 0) {
      style = "negativeGrowth";
      sign = "";
    }

    let displayValue;
    if (addBrackets === true) {
      displayValue = "(" + sign + inputValue + ")";
    } else {
      displayValue = sign + inputValue;
    }

    // return SPUtilities.moneyFormatterPrecision(inputValue, 3);
    return (<span className={style}>{displayValue}</span>);
  }

  static formatAverageDelegationUsd(cell, row) {
    if (!cell) return "N/A";
    
    let averageDelegationUsd = SPCalc.roundPrecision(cell, 0);

    return "$" + averageDelegationUsd;
  }

}

export default StakeUtils;



// WEBPACK FOOTER //
// ./src/util/StakeUtils.js